import { createSelector as ormSelector } from 'redux-orm'
import orm from  'models'
import isUuid from 'is_uuid'
import { createSelector } from "reselect";

const getEntities = state => state.entities

export const getEntitiesByIds = (entityName, ids) => {
  return ormSelector(orm, getEntities, (session) => {
    return session[entityName].filter((entity) => {   return (ids.indexOf(entity.id.toString()) > -1) } ).toModelArray().map(entity => {
      const { ref } = entity
      return { ...ref}
    })
  })
}

export const getPersistedEntities = (entityName) => {
  return ormSelector(orm, getEntities, (session) => {
    return session[entityName].filter((entity) => {   return entityPersisted(entity) } ).toModelArray()
  })
}

export function findEntity(state, entityName, id) {
  let session = orm.session(state.entities)
  return session[entityName].withId(id)
}

function entityPersisted(entity) {
  if (!entity.id) {
    return false
  }

  if(isUuid(entity.id)) {
    return false
  }

  return true
}

const getFilterDefinitions = (_, filterDefinitions) => filterDefinitions;

const getActiveFilters = (entityName) => ((state) => state.meta[entityName].filter);

export const createFilteredEntitiesSelector = (entitySelector, entityName) =>
  createSelector([entitySelector, getFilterDefinitions, getActiveFilters(entityName)],
                 (entities, filterDefinitions, activeFilters) => {
    return entities.filter((entity) => acceptEntity(entity, filterDefinitions, activeFilters))
})

const acceptEntity = (entity, filterDefinitions, activeFilters) => {
  return filterDefinitions.every((definition) => {
    const activeFilter = activeFilters?.[definition.by];

    if(!activeFilter || activeFilter.length === 0) return true
    if(definition.selectOptions) {
      return definition.getTarget(entity).some(target => activeFilter.includes(target))
    } else {
      let targetString = definition.getTarget(entity).toLowerCase()
      return (targetString.search(activeFilter.toLowerCase())) !== - 1
    }
  })
}

export default getEntities
